export default __webpack_public_path__ + "static/media/redPin.1c74f03c.svg";